export enum PlayerHand {
	Left = "left",
	Right = "right",
	Switch = "switch",
}

export enum PlayerCategory {
	NORMAL = "normal",
	STAR = "star",
	HOT = "hot",
	COLD = "cold",
}

export enum PlayerGamePosition {
	Hitter = "hitter",
	Pitcher = "pitcher",
	TwoWay = "two_way",
}

export enum PlayerPosition {
	Catcher = "catcher",
	DesignatedHitter = "designated_hitter",
	FirstBase = "first_base",
	Outfielder = "outfielder",
	Pitcher = "pitcher",
	SecondBase = "second_base",
	Shortstop = "shortstop",
	ThirdBase = "third_base",
	TwoWayPlayer = "two_way_player",
}

export enum PlayerStatus {
	Active = "active",
	Inactive = "inactive",
}

export enum PlayerImageType {
	headshot = "headshot",
	actionShotImage = "actionShotImage",
	actionFullImage = "actionFullImage",
}
